import React, { useCallback } from "react";
import { debounce } from "lodash";
import Socket from "socket";

import TOTPreGuessGuesser from "../components/TOTPreGuesGuesser";
import TOTPreGuessClueGiver from "../components/TOTPreGuessClueGiver";

const TOTPreGuess = ({
  roomId,
  category,
  isGuesser,
  onModalOpen,
  currentGuesser,
  onOpenWarningModal
}) => {
  const handleStartAction = () => {
    if (category === "") {
      onOpenWarningModal();
    } else {
      const data = {
        action: "update-status",
        roomId,
        category
      };
      Socket.sendMessage(data);
    }
  };

  const handleStart = useCallback(
    debounce(handleStartAction, 1000, {
      leading: true,
      trailing: false
    }),
    [category]
  );

  return isGuesser ? (
    <TOTPreGuessGuesser
      category={category}
      onStart={handleStart}
      onModalOpen={onModalOpen}
    />
  ) : (
    <TOTPreGuessClueGiver currentGuesser={currentGuesser} />
  );
};

export default TOTPreGuess;
